


// import { Link } from "react-router-dom";
// import {
//   FaTwitter,
//   FaFacebookF,
//   FaLinkedinIn,
//   FaWhatsapp,
//   FaEnvelope,
// } from "react-icons/fa";

// export default function BlogDetails() {
//     return (
//         <div className="bg-white font-poppins">

//             {/* ===== PAGE HEADER ===== */}
//             <div className="bg-gradient-to-b from-[#6A1B9A] to-[#9C27B0] py-10 text-white">
//                 <div className="max-w-5xl mx-auto px-4 text-center">
//                     <h1 className="text-3xl md:text-4xl font-bold">
//                         What is Mensuration Cycle
//                     </h1>

//                     <div className="mt-3 text-sm  flex flex-wrap justify-center gap-2">
//                         <span>April 11, 2022</span>
//                         <span>/</span>
//                         <span>Posted by <strong>TeamMallob</strong></span>
//                         <span>/</span>
//                         <span>775</span>
//                         <span>/</span>
//                         <span>0</span>
//                     </div>
//                 </div>
//             </div>

//             {/* ===== CONTENT ===== */}
//             <section className="max-w-4xl mx-auto px-4 py-12 text-gray-700 leading-relaxed">



//                 <h2 className="text-2xl font-bold text-blue-700 mb-4">
//                     What is Mensuration Cycle
//                 </h2>
//                 <p className="mb-6">
//                     <strong>“Leader bleed! Period.”</strong> Every year, approximately 1.8 billion women in the world menstruate. But many millions of underprivileged girls, women, and transgender people face a lot of menstrual complications, with health being the primary concern. Unfortunately, many girls find it very hard to get out of the stigma of periods. Social exclusions are one among many of those senseless practices. Due to the unconventional stigma imposed on the natural phenomenon of menstruation, women hesitate to properly express their tribulations during the cycle. However, things have been changing for the better around the world, thanks to awareness programs and strong women who broke the shackles and spoke out publicly to bring awareness to the people. Awareness is the first solution to everything. And it is every mother’s/father’s/friend’s/sibling’s right to be heedful of menstruation so they can help loved ones who are menstruating.
//                 </p>

//                 <p className="mb-10">
//                     Awareness is the first solution to everything. And it is every
//                     mother’s/father’s/friend’s/sibling’s right to be heedful of
//                     menstruation so they can help loved ones who are menstruating.
//                 </p>

//                 {/* ===== SECTION ===== */}
//                 <h2 className="text-2xl font-semibold text-blue-700 mb-4">
//                     What Is Menstruation?
//                 </h2>

//                 <p className="mb-10">
//                     Menstruation is a monthly process where blood tissues exit from the female body through the female genitals, i.e., the vagina. Generally, a female body starts menstruating during the period between 12 and 14 years of age, although it differs from individual to individual based on their body and functioning. Menstruation is proportional to the period where the human body starts evolving from childhood to adulthood, and the period of such development is called puberty. Puberty is when the body starts showcasing physical and sexual changes. Also, the puberty stage is deemed when there’s breast development, menstruation, and hair growth. The menstrual cycle is known to occur between 21 and 35 days after your initial period and lasts around 2–7 days. However, the menstrual cycle gradually lasts fewer days as you age. Periods or menstruation are not a forever process. Most females tend to stop getting their periods between the ages of 45 and 55. And this pause in periods is medically known as menopause. To be more precise, menopause is a period when a female stops getting her monthly period because of hormonal changes. When a woman reaches menopause, she is no longer able to conceive. This is because menopause starts when your ovaries stop making estrogen, thus resulting in the non-reproduction of hormones like progesterone. Without these hormones, you stop getting your period and are unable to get pregnant.
//                 </p>

//                 {/* ===== CENTER IMAGE ===== */}
//                 <div className="flex justify-center my-12">
//                     <img
//                         src="https://confidays.com/wp-content/uploads/2022/04/what-is-mensuration-cycle-confidays.png"
//                         alt="What is mensuration cycle - confidays"
//                         className="rounded-xl shadow-md max-w-full"
//                     />
//                 </div>

//                 {/* ===== STAGES ===== */}
//                 <h2 className="text-2xl font-semibold text-blue-700 mb-4">
//                     What Are The Stages Of The Menstrual Cycle?
//                 </h2>

//                 <p className="mb-4">
//                    The ovaries inside the female reproductive system release developed eggs during the menstrual cycle, which cling to the thickened uterine walls and are shed through the vagina in 3–4 days if pregnancy does not occur. This process of building up eggs and the shedding of the walls at the end is what constitutes a menstrual cycle.

// Medically, the female menstrual cycle is divided into 4 stages:
//                 </p>

//                 <ol className="list-decimal pl-6 space-y-4 mb-10 ">
//                     <li>
//                         <strong className="text-blue-700">Menstrual Phase:</strong> The first stage is when you get your monthly period. During this stage, the previously unfertilized egg (because the pregnancy hasn’t occurred) is recognized by the body due to the unused thickened walls of the uterus, which are generated to support pregnancy. Since the pregnancy is not in progress, the body sheds the walls through the vagina.
//                     </li>
//                     <li>
//                         <strong className="text-blue-700">Follicular Phase:</strong> Follicular phase is when the release of follicle-stimulating hormone takes place, i.e., on the first day of your period. During the release, only one (1) healthiest egg matures amongst the other immature eggs. The maturing follicle contributes to the thickening of uterine walls. Also, this stage creates a nutritionally abundant environment for the embryo to grow.
//                     </li>
//                     <li>
//                         <strong className="text-blue-700">Ovulation Phase:</strong> The Ovulation phase is a process when the ovaries release an egg that travels through the fallopian tube towards the uterus; there it waits to be fertilized by sperm.
//                     </li>
//                     <li>
//                         <strong className="text-blue-700">Luteal Phase:</strong>This is the stage when the shedding occurs through Vagina due to the unhappening of pregnancy.
//                     </li>
//                 </ol>

//                 {/* ===== SYMPTOMS ===== */}
//                 <h2 className="text-2xl font-semibold text-blue-700 mb-4">
//                     What Are The Symptoms Of Menstruation?
//                 </h2>
// <p>Periods are notorious for creating volatile moods in females due to the surge of hormones and the molecular changes that occur inside the reproductive system. Despite the excruciatingly flickering process, females demonstrate great courage and determination by enduring it while going about their daily lives as usual.
// </p><p>Here are the common symptoms of Menstruation:</p>
//                 <ul className="list-disc pl-6 space-y-1 mb-10">
//                     <li>Volatile mood swings</li>
//                     <li>Abdominal or pelvic cramps</li>
//                     <li>Headache & back pain</li>
//                     <li>Fatigue & insomnia</li>
//                     <li>Food cravings</li>
//                     <li>Bloating & nausea</li>
//                 </ul>

//                 {/* ===== HYGIENE ===== */}
//                 <h2 className="text-2xl font-semibold text-blue-700 mb-4">
//                     Importance of Menstrual Hygiene
//                 </h2>

//                 <p className="mb-6">
//                    It is extremely devastating that 23% of girls give up education solely because there is no proper hygienic bathroom in their schools/colleges. But it gives a clear perspective on how vital it is for females to have a perfectly hygienic environment in public or private bathrooms that prevents them from catching any bacterial/fungal infections or menstrual ailments.
//                 </p>
// <p>Fortunately, health-related organizations around the world have taken significant steps to raise awareness, particularly in low-income countries, about the importance of maintaining bathroom cleanliness and hygiene in order to protect young girls from various concerns about menstrual health. Since the last decade, MHM (Menstrual Hygiene Management) has become a global health issue and has been reported by most governments. Education is every human’s right, and no girl should be deprived of the boon because of unhealthy bathrooms.</p>
//                 <p>No matter how hard we try, one can’t emphasize enough the importance of maintaining menstrual hygiene throughout your period with proper care and attention. For these extremely vital tips, keep a checklist on hand during menstruation:</p>
//                 <h3 className="font-semibold mt-6 text-blue-700">Sanitization</h3>
//                 <p className="mb-4">
//                   Washing your vagina at equal intervals is extremely important to get rid of the dead organism that sticks to your vagina after the removal of pads. Using the right motion (from the vagina to anus) and not going backward is essential to stay healthy. Never rush things or perform hastily.
//                 </p>

//                 <h3 className="font-semibold mt-6 text-blue-700">4–6 Hour Rule</h3>
//                 <p className="mb-4">
//                   Today’s world has been gifted with the precious availability of sanitary pads, napkins, and tampons, unlike the older times when women suffered a lot due to a lack of awareness and availability. Keeping that in mind, it is extremely important to keep changing the pads every 4–6 hours. Changing your pads on a regular basis keeps you from getting a rash, urinary tract infection, or irritation.
//                 </p>

//                 <h3 className="font-semibold mt-6 text-blue-700">Say No to Soap</h3>
//                 <p className="mb-4">
//                    Water is the most pristine element that nature has to offer. There is a considerable amount of impotence for vaginal-specific products, but keep yourself aware of the fact that the female reproductive system has its own natural way of cleaning things. So the intervention of artificial products only impedes the natural cleansing system.
//                 </p>

//                 <h3 className="font-semibold mt-6 text-blue-700">Be Responsible</h3>
//                 <p className="mb-10">
//                     Menstrual hygiene is not just subject to your health. Discarding the used pads is extremely essential. Never flush your pads or be aware of touching the stains. To prevent the bacteria from spreading, wrap the pads properly and tightly before disposing of them.
//                 </p>
//                  <h3 className="font-semibold mt-6 text-blue-700">Let 1 be the one:</h3>
//                 <p className="mb-10">
//                     Menstrual hygiene is not just subject to your health. Discarding the used pads is extremely essential. Never flush your pads or be aware of touching the stains. To prevent the bacteria from spreading, wrap the pads properly and tightly before disposing of them.
//                 </p>

//                 {/* ===== CONCLUSION ===== */}
//                 <h2 className="text-2xl font-semibold text-blue-700 mb-4">
//                     Conclusion
//                 </h2>

//                 <p className="mb-10">
//                   Menstruation is a natural biological process that takes place in every female reproductive system, and it is completely fine to talk about it. Also, one must educate themselves to the fullest to be able to safely surpass their menstrual cycle without any complications.

// Also, it’s a man’s rightful responsibility to understand the process of menstruation and be in harmony with the ones they love and support them through the journey. Time has changed, and so must the people. It is about time that we normalize talking about menstruation and make those who are menstruating comfortable and confident.

// Confidays is all about bringing the right menstrual cycle awareness, providing the best hygiene and sanitation and giving women the gift of confidence everyday, whether on their period or not.
//                 </p>

//                <div className="border-t border-b py-6 my-12">
//           <div className="flex justify-center gap-6 text-gray-800 text-lg">
//             <a href="#" className="hover:text-blue-500">
//               <FaTwitter />
//             </a>
//             <a href="#" className="hover:text-blue-700">
//               <FaFacebookF />
//             </a>
//             <a href="#" className="hover:text-blue-600">
//               <FaLinkedinIn />
//             </a>
//             <a href="#" className="hover:text-green-500">
//               <FaWhatsapp />
//             </a>
//             <a href="#" className="hover:text-gray-600">
//               <FaEnvelope />
//             </a>
//           </div>
//         </div>

//         {/* ===== COMMENTS (LIKE IMAGE 2) ===== */}
//         <div className="mt-16">
//           <h3 className="text-2xl font-semibold mb-2">Leave A Reply</h3>
//           <p className="text-sm text-gray-500 mb-6">
//             Your email address will not be published. Required fields are marked
//           </p>

//           <form className="space-y-6">
//             <textarea
//               placeholder="Comment"
//               className="w-full border rounded-md p-4 h-40 focus:outline-none focus:ring-2 focus:ring-pink-500"
//             />

//             <div className="grid md:grid-cols-3 gap-4">
//               <input
//                 type="text"
//                 placeholder="Your name (required)"
//                 className="border rounded-md p-3"
//               />
//               <input
//                 type="email"
//                 placeholder="Your email (required)"
//                 className="border rounded-md p-3"
//               />
//               <input
//                 type="text"
//                 placeholder="Your website"
//                 className="border rounded-md p-3"
//               />
//             </div>

//             <label className="flex items-center gap-2 text-sm text-gray-600">
//               <input type="checkbox" />
//               Save my name, email, and website for next time.
//             </label>

//             <button
//               type="submit"
//               className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-green-700 transition"
//             >
//               POST COMMENT
//             </button>
//           </form>
//         </div>

//       </section>
//     </div>
//   );
// }







import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
  FaWhatsapp,
  FaEnvelope,
  FaInstagram,
} from "react-icons/fa";
import {AuthAPI } from "../api/AuthAPI";

export default function BlogDetails() {
  const { id } = useParams();

  const [blog, setBlog] = useState(null);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  /* ================= LOAD SINGLE BLOG ================= */
  useEffect(() => {
    if (!id) return;

   AuthAPI.getSingleBlog(id)
      .then((res) => setBlog(res.data?.data))
      .catch(console.error);
  }, [id]);

  /* ================= POST COMMENT ================= */
  async function submitComment(e) {
    e.preventDefault();

    if (!comment.trim()) return;

    try {
      setLoading(true);
      await AuthAPI.createBlogReview({
        blog_id: Number(id),
        review: comment,
      });
      setComment("");
      alert("Comment posted successfully");
    } catch (err) {
      console.error(err);
      alert("Failed to post comment");
    } finally {
      setLoading(false);
    }
  }

  if (!blog) {
    return <div className="p-10 text-center">Loading...</div>;
  }

  return (
    <div className="bg-white font-poppins mt-12 md:mt-0">

      {/* ===== PAGE HEADER ===== */}
      <div className="bg-gradient-to-b from-[#6A1B9A] to-[#9C27B0] py-10 text-white">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h1 className="text-2xl md:text-4xl font-bold">
            {blog.title}
          </h1>

          <div className="mt-3 text-sm flex flex-wrap justify-center gap-2">
       <span>{new Date(blog.createdAt).toDateString()}</span>
            <span>/</span>
            <span>
              Posted by <strong>{blog.created_by}</strong>
            </span>
          </div>
        </div>
      </div>

      {/* ===== CONTENT ===== */}
      <section className="max-w-4xl mx-auto px-4 py-12 text-gray-700 leading-relaxed">

        {/* BLOG IMAGE */}
        {blog.image && (
          <div className="flex justify-center my-12">
            <img
              src={blog.image}
              alt={blog.title}
              className="rounded-xl shadow-md max-w-full"
            />
          </div>
        )}

        {/* BLOG CONTENT */}
        <div
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />

        {/* ===== SHARE ===== */}
        <div className="border-t border-b py-6 my-12">
          <div className="flex justify-center gap-6 text-gray-800 text-lg">
            {/* <a href="#" className="hover:text-blue-500"><FaTwitter /></a> */}
            <a href="https://www.facebook.com/Confidays" className="hover:text-blue-700"><FaFacebookF /></a>
              <a
    href="https://www.instagram.com/shopconfidays/"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-pink-600"
  >
    <FaInstagram />
  </a>
            {/* <a href="#" className="hover:text-blue-600"><FaLinkedinIn /></a>
            <a href="#" className="hover:text-green-500"><FaWhatsapp /></a>
            <a href="#" className="hover:text-gray-600"><FaEnvelope /></a> */}
          </div>
        </div>

        {/* ===== COMMENTS ===== */}
        <div className="mt-16">
          <h3 className="text-2xl font-semibold mb-2">Leave A Reply</h3>
          <p className="text-sm text-gray-500 mb-6">
            Your email address will not be published. Required fields are marked
          </p>

          <form onSubmit={submitComment} className="space-y-6">
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Comment"
              className="w-full border rounded-md p-4 h-40 focus:outline-none focus:ring-2 focus:ring-pink-500"
              required
            />

            <button
              disabled={loading}
              type="submit"
              className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-green-700 transition"
            >
              {loading ? "Posting..." : "POST COMMENT"}
            </button>
          </form>
        </div>

      </section>
    </div>
  );
}
